/**
 * DigitalAssetWeekHost: verbatim render of `digital-asset-week.html`
 * (modules in ./landing/digital-asset-week/). The file's contact form has
 * no submit handler of its own; it is wired here exactly like the main
 * /contact form (same-origin fetch to POST /api/contact, honeypot, inline
 * error, success state).
 */
import { useCallback } from "react";
import { STYLES } from "./landing/digital-asset-week/styles";
import { MARKUP } from "./landing/digital-asset-week/markup";
import { SCRIPT } from "./landing/digital-asset-week/script";
import { PageHost } from "./landing/PageHost";

const LINK_MAP = { "https://t-rex.network": "/" };

function wireContactForm(host) {
  const form = host.querySelector("#contact");
  if (!form) return () => {};
  const button = form.querySelector("button[type=submit]");
  const name = form.querySelector("#f-name");
  const company = form.querySelector("#f-company");
  const email = form.querySelector("#f-email");
  const msg = form.querySelector("#f-msg");
  name.required = true;
  email.required = true;
  company.required = true;
  msg.required = true;
  button.setAttribute("data-testid", "daw-contact-submit");

  // Honeypot, identical to the main contact form
  const trap = document.createElement("input");
  trap.type = "text";
  trap.name = "website";
  trap.tabIndex = -1;
  trap.autocomplete = "off";
  trap.setAttribute("aria-hidden", "true");
  trap.style.cssText = "position:absolute;left:-10000px;width:1px;height:1px;opacity:0";
  form.appendChild(trap);

  const note = document.createElement("p");
  note.className = "label";
  note.style.marginTop = "14px";
  note.setAttribute("data-testid", "daw-contact-status");
  form.querySelector(".btns").insertAdjacentElement("afterend", note);

  let inFlight = false;
  const onSubmit = async (e) => {
    e.preventDefault();
    if (inFlight) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    inFlight = true;
    button.disabled = true;
    button.textContent = "Sending";
    note.textContent = "";
    const data = {
      name: name.value,
      email: email.value,
      company: company.value,
      role: "Digital Asset Week 2026",
      inquiry_type: "partner",
      message: msg.value,
      website: trap.value || "",
    };
    try {
      const res = await fetch("/api/contact", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
      if (!res.ok) {
        let d = {};
        try { d = await res.json(); } catch (_) { /* ignore */ }
        throw new Error((d && d.detail) || "Submission failed");
      }
      form.querySelectorAll(".two, .field, button[type=submit]").forEach((el) => { el.style.display = "none"; });
      note.textContent = "Thank you. We will be in touch shortly.";
      note.style.color = "var(--aubergine)";
    } catch (err) {
      button.disabled = false;
      button.textContent = "Send";
      note.textContent = (err && err.message) || "Submission failed";
      note.style.color = "var(--lava)";
    } finally {
      inFlight = false;
    }
  };
  form.addEventListener("submit", onSubmit);
  return () => form.removeEventListener("submit", onSubmit);
}

export function DigitalAssetWeekHost() {
  const onMount = useCallback(wireContactForm, []);
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-daw-host"
      wireLinks={true}
      linkMap={LINK_MAP}
      onMount={onMount}
      data-testid="daw-host"
    />
  );
}
